var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 10,
    fill: "#E64E4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76923 17.5L7 16.7308L11.2308 12.5L7 8.26923L7.76923 7.5L12 11.7308L16.2308 7.5L17 8.26923L12.7692 12.5L17 16.7308L16.2308 17.5L12 13.2692L7.76923 17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircleFilled);
export default __webpack_public_path__ + "static/media/XCircleFilled.592be717af10149e7cb49c99e642387a.svg";
export { ForwardRef as ReactComponent };